'use strict';

var processInclude = require('./util');

$(document).ready(function () {
    processInclude(require('./search/search'));
    processInclude(require('./product/quickView'));
    processInclude(require('./product/tileAddToCart'));
});





// WEBPACK FOOTER //
// ./cartridges/app_fh/cartridge/client/default/js/search.js